













import { Component, Prop, Vue } from 'vue-property-decorator';

interface FoodMenu {
	Price: string,
	Components: string[],
	Name: string,
}

@Component
export default class Incredient extends Vue {
	private showFullIncredients = true;
	//@ts-ignore
	@Prop() item: FoodMenu;

}
